import type { TileDisplay, WidgetType } from "@csbi/contracts"

export type DisplayKnob = keyof TileDisplay | "topN"

const NONE: readonly DisplayKnob[] = []

export const DISPLAY_SUPPORT: Record<WidgetType, readonly DisplayKnob[]> = {
  line: ["legendPosition", "showDataLabels", "area"],
  bar: ["legendPosition", "showDataLabels", "stacked", "topN"],
  "stacked-bar": ["legendPosition", "showDataLabels", "topN"],
  hbar: ["legendPosition", "showDataLabels", "topN"],
  histogram: ["legendPosition", "showDataLabels"],
  pie: ["legendPosition", "donut", "topN"],
  table: ["valueFormat", "topN"],
  "stat-tile": NONE,
  gauge: NONE,
  map: NONE,
}

export const supportsDisplay = (widget: WidgetType, knob: DisplayKnob): boolean =>
  DISPLAY_SUPPORT[widget].includes(knob)

export const barLabelsOn = (mode: TileDisplay["showDataLabels"]): boolean => mode !== "none"
